export default "__VITE_ASSET__2d2e7ec2__"